import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./app.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./app.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener } from "@angular/core";
import { AuthService } from "./shared/services/auth/auth.service";
import { AppControllerService } from "./app-controller.service";
import { WindowReference } from "./shared/classes/window-reference";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { UserInformationService } from "./shared/services/user/user-information.service";
import { AppConfig } from "./app.config";
import { RequestStatusService } from "./shared/services/request-status/request-status.service";
import { SystemModuleSettingsService } from "./shared/services/system-module-settings.service";
import { ServerNotificationService } from "./shared/services/server-notification/server-notification.service";
import { WebNotificationService } from "./shared/services/web-notification/web-notification.service";
import { Router } from "@angular/router";
import { LocalStorageService } from "./shared/services/storage/local-storage.service";
import { LocalStorageEnum } from "./shared/services/storage/local-storage-constants";
import { LocationStrategy } from "@angular/common";
import { AutoUnsub } from "./shared/decorators/autounsub.decorator";
import { Title } from "@angular/platform-browser";
import { OrganisationRoutingConstants } from "./core/organisations/organisation-settings-routing.constants";
import { AppRoutingConstants } from "./app-routing.constants";
import { BrandingService } from "./shared/services/branding/branding.service";
let AppComponent = class AppComponent {
    appController;
    authService;
    windowReference;
    bottomSheet;
    userInformationService;
    appConfig;
    requestStatusService;
    systemModuleSettingsService;
    webNotificationService;
    serverMessageService;
    router;
    localStorage;
    url;
    brandingService;
    changeDetectorRefs;
    titleService;
    branding = {
        themeMainColor: null,
        themeMainDarkerColor: null,
        themeMainBackgroundColor: null,
        themeMainBorderColor: null,
        themeHeaderBorderColor: null,
        themeActiveColor: null,
        themeActiveAlternateColor: null,
        themeLogoBackgroundColor: null,
        themePrimaryButtonColor: null
    };
    mapCenter = [-122.4194, 37.7749];
    basemapType = "satellite";
    mapZoomLevel = 12;
    $isAuthenticated;
    $userInformationFetched;
    showBusyIndicator = false;
    isMobileDevice = false;
    deferredPromptEvent;
    ON_SAME_RELOAD_STRATEGY = "reload";
    loadPublicCaptureComment = false;
    loadPublicViewDocuments = false;
    messageReceivedSubscription;
    updateDevice() {
        // lg (for laptops and desktops - screens equal to or greater than 1200px wide)
        // md (for small laptops - screens equal to or greater than 992px wide)
        // sm (for tablets - screens equal to or greater than 768px wide)
        // xs (for phones - screens less than 768px wide)
        if (window.innerWidth >= 1200) {
            this.appController.updateIsMobileDevice(false); // lg
            this.appController.updateIsSmallMobileDevice(false);
        }
        else if (window.innerWidth >= 992) {
            this.appController.updateIsMobileDevice(false); // md
            this.appController.updateIsSmallMobileDevice(false);
        }
        else if (window.innerWidth >= 768) {
            this.appController.updateIsMobileDevice(true); // sm
            this.appController.updateIsSmallMobileDevice(false);
        }
        else if (window.innerWidth < 768) {
            this.appController.updateIsMobileDevice(true); // xs
            this.appController.updateIsSmallMobileDevice(true);
        }
    }
    constructor(appController, authService, windowReference, bottomSheet, userInformationService, appConfig, requestStatusService, systemModuleSettingsService, webNotificationService, serverMessageService, router, localStorage, url, brandingService, changeDetectorRefs, titleService) {
        this.appController = appController;
        this.authService = authService;
        this.windowReference = windowReference;
        this.bottomSheet = bottomSheet;
        this.userInformationService = userInformationService;
        this.appConfig = appConfig;
        this.requestStatusService = requestStatusService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.webNotificationService = webNotificationService;
        this.serverMessageService = serverMessageService;
        this.router = router;
        this.localStorage = localStorage;
        this.url = url;
        this.brandingService = brandingService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.titleService = titleService;
        this.saveUrl();
        this.startAuthenticationProcess();
        this.setupPwaInstall(windowReference);
        this.updateDevice();
    }
    updateBusyIndicator(value) {
        if (this.showBusyIndicator !== value) {
            this.showBusyIndicator = value;
        }
    }
    // See app.component.html
    mapLoadedEvent(status) {
        this.appController.showConsoleMessage("The map loaded: " + status);
    }
    ngOnInit() {
        this.listenForBusySpinnerChanges();
        if (this.url.path().includes("/unsecure/captureComment")) {
            this.loadPublicCaptureComment = true;
            this.setRouterReloadStrategy();
        }
        else if (this.url.path().includes("/unsecure/viewDocuments")) {
            this.loadPublicViewDocuments = true;
            this.setRouterReloadStrategy();
        }
        else {
            this.loadPublicCaptureComment = false;
            this.loadPublicViewDocuments = false;
            this.$userInformationFetched = this.userInformationService.$userInformationFetched;
            this.$isAuthenticated = this.authService.$isAuthenticated;
            this.setRouterReloadStrategy();
        }
    }
    saveUrl() {
        if (!new URLSearchParams(window.location.search).has(AppRoutingConstants.START_LOGIN) && !window.location.hash.startsWith(AppRoutingConstants.TOKEN_PARAMETER)) {
            this.localStorage.set(LocalStorageEnum.Url, window.location.pathname);
        }
    }
    startAuthenticationProcess() {
        this.loadAppConfig(() => {
            this.manageLandingPage();
            const loggedIn = this.authService.checkIfLoggedIn();
            if (!loggedIn && this.url.path().includes("/unsecure/captureComment")) {
                this.loadPublicCaptureComment = true;
                this.setRouterReloadStrategy();
            }
            else if (!loggedIn && this.url.path().includes("/unsecure/viewDocuments")) {
                this.loadPublicViewDocuments = true;
                this.setRouterReloadStrategy();
            }
            else {
                this.loadPublicCaptureComment = false;
                this.authenticate();
            }
            this.titleService.setTitle(AppConfig.settings.projectSettings.title);
        });
    }
    loadAppConfig(appConfigLoadedAction) {
        this.appConfig.load().then(() => {
            appConfigLoadedAction();
            if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
                this.branding = AppConfig.settings.projectSettings.styling;
            }
            this.brandingService.setThemeColors(this.branding);
            // this.changeDetectorRefs.detectChanges();
        });
    }
    authenticate() {
        this.authService.authenticate().then((result) => {
            // this.redirectToDefaultLink();
            this.handleUserLoggedIn();
        });
    }
    setupPwaInstall(windowReference) {
        windowReference.nativeWindow.addEventListener("beforeinstallprompt", (event) => {
            event.preventDefault();
            this.deferredPromptEvent = event;
            // TODO: Re-add this
            // const bottomSheetRef = this.bottomSheet.open(PwaInstallBottomSheetComponent);
            // bottomSheetRef.afterDismissed()
            //   .pipe(takeUntil(this.ngUnsubscribe))
            //   .subscribe((result) => {
            //     if (result) {
            //       this.promptInstallPWA();
            //     }
            //   });
        });
    }
    promptInstallPWA() {
        this.deferredPromptEvent.prompt();
    }
    listenForBusySpinnerChanges() {
        this.requestStatusService.$requestBusy.subscribe(value => {
            this.showBusyIndicator = value;
            this.changeDetectorRefs.markForCheck();
        });
    }
    handleUserLoggedIn() {
        this.listenForServerMessages();
        this.redirectToDefaultLink();
    }
    listenForServerMessages() {
        this.messageReceivedSubscription = this.serverMessageService.messageReceived.subscribe((message) => {
            // TODO Dylan update this
            this.webNotificationService.showNotification("Message received", message);
        });
    }
    setRouterReloadStrategy() {
        this.router.onSameUrlNavigation = this.ON_SAME_RELOAD_STRATEGY;
    }
    busySpinnerDoubleClick() {
        this.requestStatusService.printBusyIndicators();
    }
    redirectToDefaultLink() {
        if (this.localStorage.get(LocalStorageEnum.Url)) {
            let url = this.localStorage.get(LocalStorageEnum.Url).toString();
            // this.localStorage.set(LocalStorageEnum.Url, null);
            // this.localStorage.remove(LocalStorageEnum.Url);
            url = url.replace(/"/g, "");
            url = url.replace("/afla", "");
            // if (this.extractOrganizationId(url))
            //   this.router.navigateByUrl(url);
            // if (this.extractModulId(url))
            //   this.router.navigateByUrl(url);
            const isOrg = this.extractOrganizationId(url);
            const isStep = this.extractModulId(url);
        }
    }
    extractOrganizationId(url) {
        const urlArray = url.split("/");
        const organisationId = +urlArray[1];
        const organisationRoute = urlArray[2];
        if (organisationRoute === OrganisationRoutingConstants.ORGANISATION_SETTINGS_ROUTE.replace("-", "") && organisationId) {
            this.appController.selectedOrganisationID(organisationId);
            return true;
        }
        return false;
    }
    extractModulId(url) {
        const urlArray = url.split("/");
        const moduleId = +urlArray[1];
        const stepId = urlArray[5];
        if (stepId && urlArray[4] == "step") {
            const stepId = urlArray[5];
            this.appController.updateStepToLoad(stepId);
        }
        if (moduleId) {
            this.appController.setSelectedModule(moduleId);
            return true;
        }
        return false;
    }
    manageLandingPage() {
        if (AppConfig.settings.landingPage.enableExternalLandingPage.toLowerCase() === "true") {
            const localLoginCheck = this.localStorage.get(LocalStorageEnum.Login);
            if (!localLoginCheck) {
                if (!new URLSearchParams(window.location.search).has(AppRoutingConstants.START_LOGIN) &&
                    !window.location.hash.startsWith(AppRoutingConstants.TOKEN_PARAMETER) &&
                    window.location.pathname !== AppRoutingConstants.AFLA_LOGOUT_PATH) {
                    window.location.href = AppConfig.settings.landingPage.externalLandingPageUrl;
                }
            }
        }
        return;
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: AuthService },
        { type: WindowReference },
        { type: MatBottomSheet },
        { type: UserInformationService },
        { type: AppConfig },
        { type: RequestStatusService },
        { type: SystemModuleSettingsService },
        { type: WebNotificationService },
        { type: ServerNotificationService },
        { type: Router },
        { type: LocalStorageService },
        { type: LocationStrategy },
        { type: BrandingService },
        { type: ChangeDetectorRef },
        { type: Title }
    ];
    static propDecorators = {
        updateDevice: [{ type: HostListener, args: ["window:resize", [],] }]
    };
};
AppComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-root",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AppComponent);
export { AppComponent };
